/**
 * ── Configuración de marca (white-label) ──────────────────────────────
 *
 * Toda la marca visible de la plataforma sale de aquí.
 * Para vender el producto con otro nombre: cambia estos valores
 * (y reemplaza el archivo del logo en components/GcrLogo.jsx).
 *
 * Ejemplo:
 *   export const BRAND = { name: "Señales Pro", shortName: "SP", ... }
 */
export const BRAND = {
  /** Nombre completo — aparece en títulos, emails y textos */
  name: "Gana con Ronald",

  /** Nombre corto / siglas — logo, descargas, refs de afiliado */
  shortName: "GCR",

  /** Slug sin espacios — usado en nombres de archivo y refs */
  slug: "ganaconronald",

  /** Título de la pestaña del navegador */
  tabTitle: "Gana con Ronald — BetIQ",

  /** Nombre para la ventana de soporte */
  supportTitle: "Gana con Ronald — Soporte",
};

export default BRAND;
